(() => {
  'use strict';

  const TARGET = 'rgb(11, 13, 17)';
  const TEXT_SELECTOR = [
    'h1','h2','h3','h4','h5','h6',
    'p','span','a','strong','b','em','small',
    'label','button','summary','legend',
    'li','dt','dd','th','td','figcaption'
  ].join(',');

  function applyReadableInk(root = document) {
    const elements = root.matches?.(TEXT_SELECTOR)
      ? [root, ...root.querySelectorAll(TEXT_SELECTOR)]
      : [...root.querySelectorAll(TEXT_SELECTOR)];

    for (const element of elements) {
      if (!(element instanceof HTMLElement)) continue;
      if (getComputedStyle(element).color === TARGET) {
        element.classList.add('az-readable-ink');
      }
    }
  }

  function init() {
    applyReadableInk(document);

    document.addEventListener('shopify:section:load', event => {
      if (event.target instanceof HTMLElement) applyReadableInk(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();